import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@material-ui/core/styles";
import * as React from "react";

const DEFAULT_IMAGE = "/svgs/no-photo.svg";

const useStyles = makeStyles((theme: any) => ({
  large: {
    height: 70,
    width: 70,
    [theme.breakpoints.up("md")]: {
      height: 100,
      width: 100
    }
  },
  medium: {
    height: 70,
    width: 70
  },
  noImage: {},
  small: {
    height: 24,
    width: 24,
    [theme.breakpoints.up("md")]: {
      height: 42,
      width: 42
    }
  },
  extraSmall: {
    height: 24,
    width: 24
  },
  wrapper: {
    display: "inline-block" as "inline-block",
    verticalAlign: "middle"
  }
}));

interface IProps {
  avatar: string | null | undefined;
  fullName: string;
  type?: "large" | "medium" | "small" | "extraSmall";
}

const UserAvatar = ({ fullName, avatar = "", type = "small" }: IProps) => {
  const classes = useStyles();
  return (
    <div data-avatar className={classes.wrapper}>
      <Avatar
        data-qa-selector="avatar"
        alt={fullName}
        title={fullName}
        src={avatar ? avatar : DEFAULT_IMAGE}
        className={avatar ? classes[type] : [classes.noImage, classes[type]].join(" ")}
      />
    </div>
  );
};

export default React.memo(UserAvatar);
